<template>
  <div class="main">
    <v-form ref="form" style="max-height: 118px">
      <v-container>
        <div class="title text--primary">
          {{ blacklist ? $t("maps.editor.blacklistLocationEditor") : $t("maps.editor.locationEditor") }}
        </div>
        <v-layout>
          <v-flex md2 sm12>
            <v-text-field v-model="data.name" append-icon="edit" :label="$t('common.name')" :rules="[rules.required]" single-line
              hide-details></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2 sm12>
            <v-text-field v-model="data.radius" append-icon="explore" :label="$t('maps.editor.radius')"
              :rules="[rules.required, rules.number]" single-line hide-details></v-text-field>
          </v-flex>
          <v-flex md2 sm12>
            <v-select v-if="this.id == null" :label="$t('maps.editor.cluster')" :items="['MC', 'EXT', 'PEXT']" :rules="[rules.required]"
              v-model="data.cluster" />
          </v-flex>
          <v-flex md2 sm12>
            <v-switch v-model="data.far_city" v-if="data.cluster == 'EXT'" :label="$t('maps.editor.farCity')" color="green"></v-switch>
            <!-- <v-checkbox label="Far City" v-model="data.far_city"/> -->
          </v-flex>
          <v-flex md2 sm12>
            <v-switch v-model="data.seasonal_area" v-if="data.cluster != 'MC' && data.cluster != null && mode != 'edit'"
              :label="$t('maps.editor.seasonalArea')" color="green"></v-switch>
            <!-- <v-checkbox label="Season Area" v-model="data.seasonal_area"/> -->
          </v-flex>
          <v-flex md2 sm12>
            <v-switch v-model="data.blacklisted" :label="$t('maps.editor.blacklist')" color="red"></v-switch>
            <!-- <v-checkbox label="Season Area" v-model="data.seasonal_area"/> -->
          </v-flex>
          <v-spacer></v-spacer>
          <!-- <v-flex md3 sm12 style="display: flex; align-items: center"> -->
          <!-- <div class="check-box" style="padding: 5%;"> -->
          <!-- <input type="checkbox" v-model="data.blacklisted" style="margin: 4px"/> -->
          <!-- <label -->
          <!-- class="noselect" -->
          <!-- @click="data.blacklisted = !data.blacklisted" -->
          <!-- >Mark this sector as a blacklist</label -->
          <!-- > -->
          <!-- </div> -->
          <!-- </v-flex> -->
          <!-- <v-flex md3 sm12>
            <v-text-field
              v-model="data.radius"
              append-icon="place"
              label="Radius"
              :rules="[rules.required, rules.number]"
              single-line
              hide-details
            ></v-text-field>
          </v-flex> -->
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn color="primary" dark class="mb-2" @click.stop="dialog = true">{{ $t("common.save") }}</v-btn>
          </v-flex>

          <v-dialog v-model="dialog" max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t("maps.editor.saveChanges") }}</v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat="flat" @click="dialog = false">
                  {{ $t("common.cancel") }}
                </v-btn>

                <v-btn color="primary" flat="flat" @click="save"> {{ $t("common.save") }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="diaload" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{ $t("maps.editor.savingChanges") }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
    <div id="map"></div>
  </div>
</template>
<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import centroid from "@turf/centroid";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

export default {
  name: "LocationsEditor",
  title() {
    return this.$t("maps.editor.title");
  },
  props: {
    blacklist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mode: "add", // or edit
      id: null,
      map: null,
      diaload: false,
      loading: false,
      dialog: false,
      drawComponent: null,
      answer: null,
      center: null,
      centroid: null,
      polygon: null,
      data: {
        name: null,
        radius: null,
        centroid: null,
        cluster: null,
        far_city: true,
        seasonal_area: false,
        blacklisted: false,
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
  },
  methods: {
    inside(point, vs) {
      // ray-casting algorithm based on
      // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

      var x = point[0],
        y = point[1];

      var inside = false;
      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0],
          yi = vs[i][1];
        var xj = vs[j][0],
          yj = vs[j][1];

        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
        styles: [
          {
            id: "gl-draw-polygon-fill-inactive",
            type: "fill",
            filter: ["all", ["has", "user_portColor"]],
            paint: {
              "fill-color": ["get", "user_portColor"],
              "fill-opacity": 0.5,
            },
          },
          {
            id: "gl-draw-polygon-fill-active",
            type: "fill",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#fbb03b",
              "fill-outline-color": "#fbb03b",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-midpoint",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-stroke-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Polygon"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-stroke-active",
            type: "line",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": "0.2,2",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "LineString"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-active",
            type: "line",
            filter: [
              "all",
              ["==", "$type", "LineString"],
              ["==", "active", "true"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": "0.2,2",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-point-point-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-opacity": 1,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#3bb2d0",
            },
          },
          {
            id: "gl-draw-point-stroke-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "active", "true"],
              ["!=", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 7,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["!=", "meta", "midpoint"],
              ["==", "active", "true"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-fill-static",
            type: "fill",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#404040",
              "fill-outline-color": "#404040",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-stroke-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "LineString"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-point-static",
            type: "circle",
            filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
            paint: {
              "circle-radius": 5,
              "circle-color": "#404040",
            },
          },
        ],
      });

      this.map.addControl(this.drawComponent);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
      //   this.center = this.api.mapBox.center;
      this.marker = new Mapbox.Marker({ draggable: true });
      this.marker.setLngLat(this.data.centroid);
      this.marker.addTo(this.map);
    },
    getData() {
      this.axios.get(this.baseUri + `/${this.id}`).then(({ data }) => {
        console.log('data');
        if (data.data.cluster[0] != null) {
          this.data.cluster = data.data.cluster[0].type;
          this.data.far_city = data.data.cluster[0].far_city;
        }
        console.log(data.data);
        const { name, radius, polygon } = data.data;
        this.center = centroid(polygon).geometry.coordinates;
        this.data.centroid = data.data.centroid ? data.data.centroid.coordinates : this.center;
        this.polygon = data.data.polygon.coordinates[0];
        this.loadMap();
        this.drawComponent.add(polygon);
        this.data.name = name;
        this.data.radius = radius;
        this.data.blacklisted = data.data.type === 'BLACKLIST_LOCATION' ? true : false;
      });
    },
    updateArea(e) {
      if (e.type === "draw.create") {
        this.drawComponent.deleteAll();
        this.drawComponent.add(e.features[0]);
      }
    },
    reset() {
      this.drawComponent.deleteAll();
      this.data.name = null;
      this.data.radius = null;
    },
    save() {
      if (this.mode == "edit") {
        // console.log("edit");
        this.data.centroid = {
          type: "Point",
          coordinates: this.marker.getLngLat().toArray(),
        };

        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("maps.editor.choosePolygon"));
            return;
          }
          if (this.inside(this.data.centroid.coordinates, this.polygon)) {
            this.loading = true;
            this.diaload = true;
            this.dialog = false;

            const polygon = polygons[0].geometry;
            if (this.mode != "add") {
              // delete this.data.cluster;
              // delete this.data.far_city;
              delete this.data.seasonal_area;
            }
            const url =
              this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
            (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
              polygon,
              ...this.data,
            })
              .then(() => {
                window.getApp.$emit("SHOW_TOAST", this.$t("maps.editor.saved"), "green");
                this.mode === "add" ? this.reset() : null;
              })
              .catch(() =>
                window.getApp.$emit("SHOW_TOAST", this.$t("maps.editor.notSaved"), "red")
              )
              .finally(() => {
                this.loading = false;
                this.diaload = false;
              });
          } else
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("maps.editor.centroidInsideSector"),
              "red"
            );
        }
      }

      if (this.mode == "add") {
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("maps.editor.choosePolygon"));
            return;
          }
          this.loading = true;
          this.diaload = true;
          this.dialog = false;
          if (this.data.cluster != "EXT")
            this.data.far_city = false;

          const polygon = polygons[0].geometry;
          if (!this.data.centroid)
            this.data.centroid = {
              type: "Point",
              coordinates: centroid(polygon).geometry.coordinates
            }
          const url =
            this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
          (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
            polygon,
            ...this.data,
          })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("maps.editor.saved"), "green");
              this.mode === "add" ? this.reset() : null;
            })
            .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("maps.editor.notSaved"), "red"))
            .finally(() => {
              this.loading = false;
              this.diaload = false;
            });
        }
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("maps.editor.requiredRule"),
        number: (value) => isFinite(value) || this.$t("maps.editor.mustBeNumber"),
      };
    },
    baseUri() {
      if (this.blacklist) return this.api.ACTIONS.BLACKLIST_LOCATIONS;
      else return this.api.ACTIONS.LOCATIONS;
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: calc(100vh - 64px - 118px);
}
</style>
